
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeactivateBusinessComponent } from '../deactivate-business/deactivate-business.component';
import { SharedService } from '../../../providers/shared.service';

@Component({
  selector: 'sm-business-list',
  templateUrl: './business-list.component.html',
  styleUrls: ['./business-list.component.scss']
})
export class BusinessListComponent implements OnInit, OnDestroy {

  messageList: any[] = [];
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "business name",
      columnProperty: "entityName"
    },
    {
      columnName: "address",
      columnProperty: "addressInfo"
    },
    {
      columnName: "date of joining",
      columnProperty: "senderPhone"
    },
    
    
    {
      columnName: "status",
      columnProperty: "isActive"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService, private _apiService: ApiService,private dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_ENTITY_DETAILS_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        console.log( this.messageList);
        this.messageList.forEach((item )=> {
          if(item.addressInfo && item.addressInfo!= null){
            item.addressInfo = (JSON.parse(item.addressInfo)).address_line
          }
          if(item.isActive == '2' ||item.isActive == '3' ){
            item.isActive = 'Deleted'
          }
          if(item.isActive == '1'){
            item.isActive = 'Active'
          }
          if(item.isActive == '0'){
            item.isActive = 'Deactive'
          }
         
        })
            console.log( this.messageList);
        
      }
      this.loader = false;
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this._apiService.getAllEntity();
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

  // test(row:any){
  //   console.log(row);
    
  // }
  viewDocs(entityHash: string){
  console.log("clicked");
  this.router.navigate(['/businesses','documents'], {queryParams: {'entityHash' : entityHash}})
}

viewDetails(entityHash: string){
  console.log(entityHash);
  this.router.navigate(['/businesses','details'], {queryParams: {'entityHash' : entityHash}})
  
}
viewOnlinePayments(entityHash: string){
  console.log(entityHash);
  this.router.navigate(['/businesses','onlinePayments'], {queryParams: {'entityHash' : entityHash}})
}
viewServices(entityHash: string){
// console.log(entityHash);
this.router.navigate(['/businesses','services'], {queryParams: {'entityHash' : entityHash}})
}

viewBookings(entityHash: string){
  this.router.navigate(['/businesses','bookings'], {queryParams: {'entityHash' : entityHash}})
}
viewEmployees(entityHash: string){
  this.router.navigate(['/businesses','employees'], {queryParams: {'entityHash' : entityHash}})
}

deactivate(rowvalue:any) {
  console.log(rowvalue);
  rowvalue.type = 'deactivate'
 
  this.dialog.open(DeactivateBusinessComponent, {
    height: '350px',
    disableClose: true,
    data: {
      ref: this.dialog,
      data:rowvalue
    }
  });
}

activate(rowvalue:any){
  console.log(rowvalue);
  rowvalue.type = 'activate'
  this.dialog.open(DeactivateBusinessComponent, {
    height: '350px',
    disableClose: true,
    data: {
      ref: this.dialog,
      data:rowvalue
    }
  });
}
}
